import React, {
    forwardRef,
    useRef,
    useImperativeHandle,
    useCallback,
} from 'react';
import { noop, get } from 'lodash';
import moment from 'moment';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import ErrorMessage from 'components/Common/ErrorMessage';
import { useNodeContext } from 'contexts/NodeProvider';
import './Input.scss';

const DatePicker = forwardRef(
    (
        {
            label,
            name,
            required,
            value,
            onChange,
            disabled,
            minDate = '1753-01-01',
            maxDate = '9999-12-31',
            pastOnly,
            start,
            error,
            type,
            ...rest
        },
        ref
    ) => {
        const idStr = `${Math.round(Math.random() * 1000)}`;
        return (
            <Form.Group className="datepicker-field">
                <Form.Label className="datepicker-label" htmlFor={idStr}>
                    {label}
                    <span className="text-danger">{required ? ' *' : ' '}</span>
                </Form.Label>
                <input
                    ref={ref}
                    type={type || 'date'}
                    className="datepicker-input"
                    id={idStr}
                    data-testid={name}
                    name={name}
                    pattern="MM/dd/yyyy"
                    value={value}
                    min={minDate}
                    max={pastOnly ? moment().format('YYYY-MM-DD') : maxDate}
                    disabled={disabled}
                    onChange={onChange}
                    {...rest}
                />
                <ErrorMessage message={error} />
            </Form.Group>
        );
    }
);
const DatePickerWithController = forwardRef(
    (
        {
            control,
            name,
            defaultValue,
            label,
            disabled,
            required,
            value,
            onChange = noop,
            registerRef = true,
            ...rest
        },
        ref
    ) => {
        const _ref = useRef();
        const { nodesRef } = useNodeContext();

        useImperativeHandle(ref, () => _ref.current);
        return (
            <Controller
                control={control}
                name={name}
                defaultValue={defaultValue}
                render={({
                    field: {
                        onChange: handleChange,
                        value: formValue,
                        ref: rhfRef,
                    },
                    fieldState: { error },
                }) => {
                    const onRefChange = useCallback((node) => {
                        if (registerRef) {
                            _ref.current = node;
                            rhfRef = _ref;
                            if (nodesRef) {
                                nodesRef.current[name] = node;
                            }
                        }
                    }, []);
                    return (
                        <DatePicker
                            ref={onRefChange}
                            name={name}
                            label={label}
                            disabled={disabled}
                            value={value ?? formValue}
                            onChange={(e) => {
                                onChange(e);
                                handleChange(e);
                            }}
                            required={required}
                            error={get(error, 'message')}
                            {...rest}
                        />
                    );
                }}
            />
        );
    }
);
export { DatePickerWithController as default, DatePicker };
